import Title from 'src/refactor_components/common/Title';

import { FileUpload } from 'src/refactor_shared/ui/FileUpload';

export const CurriculumImage = () => {
  return (
    <div>
      <Title text="수업사진" />
      <FileUpload registerName={'images'} maxCount={10} path={'image'} />
    </div>
  );
};
